/**
 * 通用的下载方法
 */
export const downloadFileByLink = (url: string, name: string) => {
    try {
        const a = document.createElement('a');
        a.href = url;
        a.download = name || new Date().getTime().toString();
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
        URL.revokeObjectURL(url);
        return Promise.resolve();
    } catch (error) {
        return Promise.reject(error);
    }
};

/**
 * 下载 Blob 数据
 * @param blob Blob 数据
 * @param filename 文件名
 * @param mimeType MIME 类型，可选
 */
export const downloadBlob = (blob: Blob, filename: string, mimeType?: string) => {
    try {
        // 如果指定了 MIME 类型，创建新的 Blob
        const downloadBlob = mimeType ? new Blob([blob], { type: mimeType }) : blob;

        // 创建下载链接
        const url = URL.createObjectURL(downloadBlob);

        // 创建临时 a 标签进行下载
        const a = document.createElement('a');
        a.href = url;
        a.download = filename;
        a.style.display = 'none';

        // 添加到 DOM，触发下载，然后移除
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);

        // 释放 URL 资源
        URL.revokeObjectURL(url);

        return Promise.resolve();
    } catch (error) {
        console.error('下载文件失败:', error);
        return Promise.reject(error);
    }
};

/**
 * 视频文件下载
 * 使用 fetch 获取视频 Blob 后下载，避免分片下载导致文件损坏的问题
 * 同时解决跨域 URL 无法直接使用 a 标签下载的问题
 * @param videoUrl 视频 URL
 * @param fileName 文件名（可选，默认从 URL 提取）
 */
export async function downloadVideo(videoUrl: string, fileName?: string): Promise<void> {
    if (!videoUrl) {
        throw new Error('视频 URL 不能为空');
    }

    // 如果没有提供文件名，尝试从 URL 提取
    let downloadFileName = fileName;
    if (!downloadFileName) {
        try {
            const urlObj = new URL(videoUrl);
            const pathParts = urlObj.pathname.split('/');
            const extractedName = pathParts.pop();
            downloadFileName = extractedName || `video_${Date.now()}.mp4`;
        } catch {
            downloadFileName = `video_${Date.now()}.mp4`;
        }
    }

    // 确保文件名有扩展名
    if (!downloadFileName.includes('.')) {
        downloadFileName += '.mp4';
    }

    // 使用 fetch 获取视频 Blob，解决跨域下载问题
    const response = await fetch(videoUrl);
    if (!response.ok) {
        throw new Error(`下载失败: ${response.status} ${response.statusText}`);
    }

    const blob = await response.blob();
    const url = URL.createObjectURL(blob);

    try {
        const a = document.createElement('a');
        a.href = url;
        a.download = downloadFileName;
        a.style.display = 'none';
        document.body.appendChild(a);
        a.click();
        document.body.removeChild(a);
    } finally {
        // 释放 Blob URL
        URL.revokeObjectURL(url);
    }
}